import { render, staticRenderFns } from "./Crisiscases.vue?vue&type=template&id=cfd3ec60&scoped=true"
import script from "./Crisiscases.vue?vue&type=script&lang=js"
export * from "./Crisiscases.vue?vue&type=script&lang=js"
import style0 from "./Crisiscases.vue?vue&type=style&index=0&id=cfd3ec60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd3ec60",
  null
  
)

export default component.exports